export class TabSubmissionPutPost {
    user: number | null = null;
    status: number = 0;
    name: string = '';
    text: string = '';
    media_link: string | null = null;
    game: number | null = null;
    requested_game: string | null = null;
    instruments: number[] = [];
    composers: number[] = [];
    styles: number[] = [];
    requested_instruments: string[] = [];
    requested_composers: string[] = [];
    requested_styles: string[] = [];
}
